import N8nEmptyState from './EmptyState.vue';

export type { EmptyStateCardIcon, EmptyStateIconCards } from './types';

export default N8nEmptyState;
